angular
  .module 'filters'
  .filter 'htmlToText', ->
    (data) ->
      angular.element("<div>#{data}</div>").text()
